import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTable32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconTable32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8 7h16a2 2 0 0 1 2 2v1H6V9a2 2 0 0 1 2-2m-4 5V9a4 4 0 0 1 4-4h16a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4zm2 10v1a2 2 0 0 0 2 2h3v-3zm13 3h-6v-3h6zm2 0h3a2 2 0 0 0 2-2v-1h-5zm0-5h5v-3h-5zm-2-3h-6v3h6zm0-2h-6v-3h6zm2 0h5v-3h-5zM6 12h5v3H6zm5 8v-3H6v3z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconTable32);
